{
  "clear": "Clear",
  "panel": "Controls",
  "showSettings": "Show settings",
  "hideSettings": "Hide settings",
  "mode": {
    "forecast": "Forecast",
    "explore": "Explore"
  },
  "sections": {
    "wind": "Wind",
    "explore": "Explore",
    "settings": "Settings"
  },
  "exploreHelp": {
    "label": "What does Explore show?",
    "text": "Pick a point on the map to see its glide cone: the area you can reach by gliding. <mode>Fly</mode> shows where you can land from a takeoff; <mode>Hike</mode> shows where you can take off from and still reach a landing zone. Glides are in still air at your glide ratio and go around terrain in the way. Colours show the height you have left, above the ground (<mode>Fly</mode>) or above the landing zone (<mode>Hike</mode>): red is little, blue is plenty. Purple marks the max radius, where more may be reachable beyond it."
  }
}
